export default __webpack_public_path__ + "static/media/Sage's Hand-wraps of the Aureate.2629ecc8.jpg";